import { useCallback } from 'react';
import { markPdlDecisionReviewPathTourDismissed } from '../../../lib/pdlDecision/pdlDecisionTourStorage';
import { PDL_TOUR_TARGETS } from '../../../lib/pdlDecision/buildPdlDecisionReviewPathSteps';
import { SpotlightTourOverlay } from '../../employerReview/guidedTour/SpotlightTourOverlay';
import { usePdlDecisionTourOptional } from './PdlDecisionTourContext';

function applyPdlReviewPathStepEnter(
  stepIndex: number,
  steps: { target: string }[],
  nav: NonNullable<ReturnType<typeof usePdlDecisionTourOptional>>,
) {
  const target = steps[stepIndex]?.target;

  if (target === PDL_TOUR_TARGETS.technical) {
    nav.setTechnicalOpen(true);
    nav.setRemarksOpen(false);
    return;
  }

  if (target === PDL_TOUR_TARGETS.policy) {
    nav.setRemarksOpen(true);
    nav.setTechnicalOpen(false);
    return;
  }

  nav.setTechnicalOpen(false);
  nav.setRemarksOpen(false);
}

export function PdlDecisionReviewPathTour() {
  const nav = usePdlDecisionTourOptional();
  const active = nav?.reviewPathTour ?? null;

  const onStepEnter = useCallback(
    (stepIndex: number) => {
      if (!nav || !active) return;
      applyPdlReviewPathStepEnter(stepIndex, active.steps, nav);
    },
    [active, nav],
  );

  if (!nav || !active) return null;

  const dismiss = () => {
    markPdlDecisionReviewPathTourDismissed();
    nav.closeReviewPathTour();
  };

  return (
    <SpotlightTourOverlay
      steps={active.steps}
      stepIndex={active.stepIndex}
      ariaLabelId="pdl-decision-review-path-tour-title"
      onStepEnter={onStepEnter}
      onSkip={dismiss}
      onBack={() => nav.prevReviewPathStep()}
      onNext={() => {
        if (active.stepIndex >= active.steps.length - 1) dismiss();
        else nav.nextReviewPathStep();
      }}
    />
  );
}
